import React, { useEffect, useState } from 'react'
import { DashboardContainer } from '../../funcs/utils'
import Line from './components/Line';
import { dollarToString } from '../../../lib/currency-utils';
import LineTabs from './components/LineTabs';
import './styles.css'

const PerformanceCard = ({ client, performanceData }) => {
    // Get Tabs and Reorder Tabs into desired order
    const tabSet = new Set([...Object.keys(performanceData)]);
    const tabOrder = ['days_5', 'month', 'month_6', 'year_1', 'year_5', 'ytd_weekly'];
    const tabs = tabOrder.filter(key => tabSet.has(key));

    if (!performanceData || !performanceData.days_5 || performanceData.days_5.length < 5) {
        return null;
    }

    // useState
    const [activeTab, setActiveTab] = useState(tabs[0]);

    // Set Data
    const lineData = performanceData[activeTab];
    const latestLineData = lineData[lineData.length - 1];
    const [value, setValue] = useState(latestLineData.price);

    // Selected Tab Color
    const color = client.color.sign_on_button;

    useEffect(() => {
        setValue(latestLineData.price);
    }, [activeTab]);

    return (
        <DashboardContainer title={'Portfolio Value'} client={client} >
            <div style={{ display: 'flex', margin: '0 auto', marginTop: '16px' }}>
                <div style={{ fontWeight: 'bold', fontSize: '25px', flex: '1 1 auto'}}>{dollarToString(value)}</div>
            </div>
            
            <div className='line-chart-container'>
                <Line data={lineData} setValue={setValue} />

                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                    <LineTabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} color={color} />
                </div>
            </div>
        </DashboardContainer>
    )
}

export default PerformanceCard